
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/meet-the-team",
      function () {
        return require("private-next-pages/about-us/meet-the-team/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/meet-the-team"])
      });
    }
  